import React from 'react';
import { DATE_FORMAT, useDateService } from 'framework/utils';
import { Tooltip } from 'framework/ui/mui-builder';
import moment from 'moment';

interface RelativeDateWithTooltipProps {
  date: string | null | undefined;
  hideAgo?: boolean;
  showIn?: boolean;
  archivingDate?: string | null;
  expandedUnits?: boolean;
}

const RelativeDateWithTooltip = ({
  date,
  archivingDate = null,
  hideAgo = false,
  showIn = false,
  expandedUnits = false,
}: RelativeDateWithTooltipProps) => {
  const { datesDifference, datesDifferenceExpanded, getToday, formatDateForAPI } = useDateService();

  if (!date) return null;

  const formattedDate = hideAgo || showIn ? formatDateForAPI(date) : date;
  const relativeDate = datesDifference(
    archivingDate ? moment(archivingDate) : getToday(),
    formattedDate,
    hideAgo,
    showIn,
  );
  const displayRelativeDate = expandedUnits
    ? datesDifferenceExpanded(archivingDate ? moment(archivingDate) : getToday(), formattedDate, hideAgo, showIn)
    : relativeDate;
  const absoluteDate = archivingDate
    ? `${moment(date).format(DATE_FORMAT.API_ONLY_DATE)} — ${moment(archivingDate).format(DATE_FORMAT.API_ONLY_DATE)}`
    : moment(date).format(DATE_FORMAT.API_ONLY_DATE);

  return (
    <Tooltip title={absoluteDate}>
      <span>{displayRelativeDate}</span>
    </Tooltip>
  );
};

export default RelativeDateWithTooltip;
